// src/components/Seamless.jsx
import React, { useRef, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import before from "../assets/Before.png";
import after from "../assets/images/bothra_office/bothra-main.jpg";
import { useNavigate } from "react-router-dom";

const Seamless = () => {
  const containerRef = useRef(null);
  const [position, setPosition] = useState(50);
  const navigate = useNavigate();

  const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

  const updatePositionFromClientX = (clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clamp(clientX - rect.left, 0, rect.width);
    const percent = (x / rect.width) * 100;
    setPosition(percent);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    updatePositionFromClientX(e.clientX);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => updatePositionFromClientX(e.clientX);
  const handleMouseUp = () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    updatePositionFromClientX(touch.clientX);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);
  };

  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    updatePositionFromClientX(touch.clientX);
  };

  const handleTouchEnd = () => {
    window.removeEventListener("touchmove", handleTouchMove);
    window.removeEventListener("touchend", handleTouchEnd);
  };

  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        px: { xs: 2, md: 8 },
        textAlign: "center",
        bgcolor: "#ffffff",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontFamily: "serif",
          fontWeight: 500,
          color: "#c2a76b",
          mb: 2,
          fontSize: { xs: "2rem", md: "2.6rem" },
        }}
      >
        A Seamless Experience
      </Typography>

      {/* <Typography
        variant="body1"
        sx={{
          color: "#777",
          maxWidth: 700,
          mx: "auto",
          mb: { xs: 5, md: 6 },
        }}
      >
        Before & After Bothra Shipping Corporate Office
      </Typography> */}

      {/* BEFORE / AFTER IMAGE SLIDER */}
      <Box
        ref={containerRef}
        sx={{
          position: "relative",
          maxWidth: 960,
          mx: "auto",
          aspectRatio: "16/9",
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "0 16px 40px -24px rgba(0,0,0,.35)",
          mb: { xs: 4, md: 5 },
          backgroundColor: "#000",
          cursor: "ew-resize",
        }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      >
        {/* BEFORE IMAGE */}
        <img
          src={after}
          alt="Before"
          style={{
            width: "100%",
            height: "100%",
            // objectFit: "cover",
            position: "absolute",
            inset: 0,
          }}
        />

        {/* AFTER IMAGE (clipped) */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            width: `${position}%`,
            overflow: "hidden",
          }}
        >
          <img
            src={before}
            alt="After"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>

        {/* Vertical Divider Line */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: `${position}%`,
            width: "2px",
            transform: "translateX(-50%)",
            bgcolor: "rgba(255,255,255,0.95)",
            pointerEvents: "none",
          }}
        />

        {/* Drag Handle */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: `${position}%`,
            transform: "translate(-50%, -50%)",
            width: 56,
            height: 56,
            borderRadius: "50%",
            border: "2px solid #d1b271",
            bgcolor: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 6px 16px rgba(0,0,0,.25)",
            pointerEvents: "none",
            fontSize: 22,
            fontWeight: "bold",
            color: "#d1b271",
          }}
        >
          {"< >"}
        </Box>
      </Box>

      {/* <Typography
        variant="body1"
        sx={{
          color: "#777",
          maxWidth: 700,
          mx: "auto",
          mb: { xs: 3, md: 4 },
        }}
      >
        While we do the heavy lifting, all you need to do is walk into your brand new space.
      </Typography> */}

      <Button
        variant="outlined"
        sx={{
          borderRadius: 0,
          px: 5,
          py: 1.5,
          borderColor: "#d1b271",
          color: "#d1b271",
          fontWeight: 500,
          letterSpacing: 1,
          fontSize: 14,
          "&:hover": {
            borderColor: "#c09a4b",
            bgcolor: "rgba(209,178,113,0.06)",
          },
        }}
        onClick={() => navigate("/projects")}
      >
        SEE ALL PROJECTS
      </Button>
    </Box>
  );
};

export default Seamless;
